import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { URL } from "../../api";
import axiosInstance from "../../Request";
const SetAssignModal = ({
  assignModalOpen,
  setAssignModalOpen,
  selectedUserA,
  setSelectedUserA,
  selectedUserB,
  setSelectedUserB,
  userList
}) => {

  const handleAssign = async () => {
    if (!selectedUserA || !selectedUserB) {
      alert("Please select both users");
      return;
    }

    try {
      const response = await axiosInstance.post(
        URL.ASSIGN_BULK_PRIVILEGE,
        {
          from_user_id: selectedUserA,
          to_user_id: selectedUserB,
        },
        {
          withCredentials: true,
        }
      );

      const data = response.data;
      alert("Privileges assigned successfully");
      console.log("API Response:", data);

      setAssignModalOpen(false);
    } catch (error) {
      console.error("Error assigning privileges:", error);
      alert("Something went wrong while assigning privileges");
    }
  };
  

  return (
    <Modal isOpen={assignModalOpen} toggle={() => setAssignModalOpen(false)}>
      <ModalHeader toggle={() => setAssignModalOpen(false)}>Assign Privileges</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="userA">Privilage From</Label>
            <Input
              type="select"
              id="userA"
              value={selectedUserA}
              onChange={(e) => setSelectedUserA(e.target.value)}
            >
              <option value="">--Select User--</option>
              {userList.map(user => (
                <option key={user.id} value={user.id}>
                  {user.user_name} -- {user.name}
                </option>
              ))}
            </Input>
          </FormGroup>

          <FormGroup>
            <Label for="userB">Privilage To</Label>
            <Input
              type="select"
              id="userB"
              value={selectedUserB}
              onChange={(e) => setSelectedUserB(e.target.value)}
            >
              <option value="">--Select User--</option>
              {userList.map(user => (
                <option key={user.id} value={user.id}>
                  {user.user_name} -- {user.name}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleAssign}>Assign</Button>
      </ModalFooter>
    </Modal>
  );
};

export default SetAssignModal;
